import debounce from 'lodash.debounce';

export default class DynamicCards {
  static dynamicCards() {
    return Array.from(document.querySelectorAll('.dynamic-card'));
  }

  init() {
    // Markup example:
    // <div class="dynamic-card">
    //   ...
    // </div>

    window.addEventListener(
      'resize',
      debounce(() => {
        DynamicCards.updateAllDynamicCards(true);
      }, 300),
      window.supportPassive
    );

    DynamicCards.updateAllDynamicCards();
  }

  static updateAllDynamicCards(force = false) {
    this.dynamicCards().forEach((dynamicCard) => {
      DynamicCards.updateOneDynamicCard(dynamicCard, force);
    });
  }

  static updateOneDynamicCard(dynamicCard, force = false) {
    if (!force && dynamicCard.classList.contains('dynamic-card--initialized')) {
      return;
    }

    dynamicCard.classList.add('dynamic-card--initialized');
    dynamicCard.style.setProperty(
      '--dynamic-card-min-height',
      `${dynamicCard.getBoundingClientRect().height}px`
    );

    if (dynamicCard.dataset.dynamicCardBaseClass) {
      dynamicCard.classList.add(
        `${dynamicCard.dataset.dynamicCardBaseClass}--initialized`
      );
    }
  }
}
